import { render, staticRenderFns } from "./BaseComposeNotifyDialog.vue?vue&type=template&id=40e49b17&scoped=true&"
import script from "./BaseComposeNotifyDialog.vue?vue&type=script&lang=js&"
export * from "./BaseComposeNotifyDialog.vue?vue&type=script&lang=js&"
import style0 from "./BaseComposeNotifyDialog.vue?vue&type=style&index=0&id=40e49b17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e49b17",
  null
  
)

export default component.exports